/**
 * Pastille de série de bonnes réponses consécutives (mode correction visible).
 * Purement décorative — le compteur vit dans Quiz.jsx. La `key` sur le streak
 * relance l'animation pop à chaque incrément.
 */
function StreakBadge({ streak }) {
    if (!streak || streak < 2) return null;
    const chaud = streak >= 5;
    return (
        <span
            key={streak}
            className="quiz-streak-pop flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-extrabold flex-shrink-0"
            style={{
                fontFamily: 'Fredoka',
                background: chaud ? 'rgba(249,115,22,.9)' : 'rgba(249,115,22,.22)',
                color: chaud ? '#fff' : '#FBC19A',
                border: '1px solid rgba(249,115,22,.5)',
            }}
            title={`${streak} bonnes réponses d'affilée`}
        >
            🔥 x{streak}
        </span>
    );
}

export default StreakBadge;
